import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/home/Home'
import Login from '../components/login/Login'
import UserList from '../pages/users/UserList'
import UserDetails from '../pages/users/UserDetails'
import ProviderList from "../pages/providers/ProviderList"
import ProviderDetails from "../pages/providers/ProviderDetails"
import PayList from "../pages/pay/PayList";
import CashBackList from "../pages/cashback/CashBackList";
import VeteranList from '../pages/veteran/VeteranList.vue'
import Tools from "../pages/tools/Tools";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/userList',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/providerList',
      name: 'ProviderList',
      component: ProviderList
    },
    {
      path: '/payList',
      name: 'PayList',
      component: PayList
    },
    {
      path: '/cashbackList',
      name: 'CashBackList',
      component: CashBackList
    },
    {
      path: '/veteranList',
      name: 'VeteranList',
      component: VeteranList
    },
    {
      path: '/tools',
      name: 'Tools',
      component: Tools
    },
    {
      path: '/user/details',
      name: 'UserDetails',
      component: UserDetails
    },
    {
      path: '/provider/details',
      name: 'ProviderDetails',
      component: ProviderDetails
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let token = localStorage.getItem('Authorization');
    if (token === null || token === '') {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js